<template>
  <div class="wapers-page container">
    <TheBreadcrumb :pages="arianeRoute" />
    <HeaderCommunity :page="currentPageInfo" />
    <SearchResults :with-search="false">
      <template #title>
        <h2 class="title-strat">Les Wapers les plus influents</h2>
      </template>
      <template #results>
        <WaperContainer :items="communityWapers" />
      </template>
    </SearchResults>
    <ThePagination
      :total-pages="communityWapersPages"
      :current-page="communityWapersCurrentPage"
      :go-to="changePageTo"
    />
    <PegiWarning v-if="community?.pegi === '18'" />
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  middleware: async (to) => {
    const loadWapersCommunity = useLoadWapersCommunity()
    return loadWapersCommunity(to)
  },
})

const route = useRoute()

const communitiesStore = useCommunitiesStore()
const { community } = storeToRefs(communitiesStore)

const wapersStore = useWapersStore()
const { communityWapers, communityWapersPages, communityWapersCurrentPage } =
  storeToRefs(wapersStore)

const referentialStore = useReferentialStore()
const { referential } = storeToRefs(referentialStore)

const arianeRoute = ref([
  {
    title: `${route.params.communityName}`,
    route: `/communautes/${route.params.communityName}`,
  },
  {
    title: 'Les wapers',
    route: ``,
  },
])

const breadcrumbSchema = useBreadcrumbSchema({
  arianeRoute,
})

const link = useLinkPrevNext({
  currentPage: communityWapersCurrentPage,
  pagesCount: communityWapersPages,
})

useHead({
  title: `Wapers de la communauté ${community.value?.title}`,
  link,
  script: [breadcrumbSchema],
})

useSeoMeta({
  title: `Wapers de la communauté ${community.value?.title}`,
  description: `Découvrez et rencontrez tous les joueurs de la communauté ${community.value?.title}. Rejoignez les communautés : Jouez, notez et recommandez vos jeux vidéo favoris !`,
  ogTitle: 'Tous les Wapers de la communauté ' + community.value?.title,
  ogDescription:
    'Découvrez et rencontrez tous les joueurs de la communauté ' +
    community.value?.title,
  ogImage:
    community.value?.image_desktop?.url ??
    'https://www.weareplaystation.fr/img/og-img.jpg',
})
const mediaQuery = useCustomMediaQuery()

const currentPageInfo = computed(() => {
  const image = getImage(community, mediaQuery)

  return {
    title: 'Les wapers',
    game: community.value?.title,
    pegi: community.value?.pegi,
    members: community.value?.users_count,
    image,
    contribPoints: referential.value?.points.post_source_create,
    description: `Découvrez et rencontrez tous les joueurs de la communauté ${community.value?.title}`,
  }
})

const wapersPerPage = ref(40)

const changePageTo = async (index = 1) => {
  if (index > 0) {
    wapersStore.fetchCommunityWapers({
      page: index,
      community: route.params.communityName as string,
      limit: wapersPerPage.value,
    })
  }
}
</script>

<style lang="scss" scoped>
.wapers-page {
  min-height: 100vh;
  padding-bottom: 10rem;
}
</style>
